<div class="bsq-page">
  <div class="bsq-grid">
    <button
      *ngFor="let q of questions"
      type="button"
      class="bsq-card"
      [id]="'bsq-card-' + q.id"
      [class.is-sealed]="isSealed(q.id)"
      [attr.aria-label]="'Question ' + q.id + ': ' + q.question"
      (click)="open(q)">
      <span class="bsq-corner bsq-corner--tl">&#10086;</span>
      <span class="bsq-corner bsq-corner--br">&#10086;</span>
      <span class="bsq-num">NO. {{ cardNumber(q.id) }}</span>
      <span class="bsq-question">{{ q.question }}</span>
      <span class="bsq-rule"></span>
      <span class="bsq-seal" *ngIf="isSealed(q.id)">&#10022;</span>
      <span class="bsq-shimmer" *ngIf="!isSealed(q.id)"></span>
    </button>

    <button
      *ngIf="allPlayed"
      type="button"
      class="bsq-card bsq-card--bonus"
      [id]="'bsq-card-' + bonus.id"
      [class.is-sealed]="isSealed(bonus.id)"
      [attr.aria-label]="'Bonus question: ' + bonus.question"
      (click)="open(bonus)">
      <span class="bsq-corner bsq-corner--tl">&#10022;</span>
      <span class="bsq-corner bsq-corner--br">&#10022;</span>
      <span class="bsq-num">BONUS</span>
      <span class="bsq-question">{{ bonus.question }}</span>
      <span class="bsq-rule"></span>
      <span class="bsq-seal" *ngIf="isSealed(bonus.id)">&#10022;</span>
      <span class="bsq-shimmer" *ngIf="!isSealed(bonus.id)"></span>
    </button>
  </div>

  <div class="bsq-overlay" *ngIf="openCard as card" (click)="close()">
    <div class="bsq-stage" (click)="$event.stopPropagation()">
      <button type="button" class="bsq-close" aria-label="Close" (click)="close()">&#10005;</button>

      <p class="bsq-stage-num">{{ card.id === bonus.id ? 'BONUS' : 'NO. ' + cardNumber(card.id) }}</p>
      <h2 class="bsq-stage-question">{{ card.question }}</h2>
      <span class="bsq-rule bsq-rule--stage"></span>

      <div class="bsq-video-frame">
        <video
          #player
          *ngIf="!videoFailed"
          class="bsq-video"
          [src]="card.videoUrl"
          playsinline
          [controls]="playStarted"
          preload="metadata"
          (error)="onVideoError()"></video>

        <p class="bsq-missing" *ngIf="videoFailed">Video coming soon &#128140;</p>

        <button
          type="button"
          class="bsq-bigplay"
          *ngIf="!playStarted && !videoFailed"
          aria-label="Play his answer"
          (click)="startVideo()"></button>
      </div>

      <span
        class="bsq-petal"
        *ngFor="let p of petals"
        [class.is-gold]="p.gold"
        [ngStyle]="{
          '--bsq-angle': p.angle + 'deg',
          '--bsq-distance': p.distance + 'px',
          '--bsq-delay': p.delay + 'ms'
        }"></span>
    </div>
  </div>
</div>
